import moment from 'moment'

export default class TypeUtils {
    static RX_DATE = /\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}:\d{2}(?:\.\d{3})?(?:\+[\d:]{4,})?/

    static isDate (s) {
        return this.RX_DATE.test(s)
    }

    static formatUtcDate(date, format, defaultValue = '') {
        if (typeof date !== 'string') {
            return defaultValue
        }

        var m = moment.utc(date)
        return m.isValid()
            ? m.local().format(format)
            : defaultValue
    }

    static formatLocalDate(date, format, defaultValue = '') {
        if (typeof date !== 'string') {
            return defaultValue
        }

        var m = moment(date)
        return m.isValid()
            ? m.utc().format(format)
            : defaultValue
    }
}
